import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, LinearProgress } from '@mui/material';
import { useSubscription } from '../../hooks/useSubscription';

export function TrialBanner() {
  const navigate = useNavigate();
  const { data: subscriptionData, isLoading } = useSubscription();

  // Don't show if loading or not on trial
  if (isLoading) return null;

  const subscription = subscriptionData?.subscription;
  if (!subscription || subscription.status !== 'trialing') return null;

  const daysRemaining = subscription.trialDaysRemaining;
  const totalTrialDays = 14;
  const daysUsed = totalTrialDays - daysRemaining;
  const progress = (daysUsed / totalTrialDays) * 100;

  // Determine urgency color
  const getColor = () => {
    if (daysRemaining <= 3) return 'error';
    if (daysRemaining <= 7) return 'warning';
    return 'info';
  };

  const color = getColor();

  return (
    <Box
      sx={{
        bgcolor: color === 'error' ? 'error.light' : color === 'warning' ? 'warning.light' : 'info.light',
        color: color === 'error' ? 'error.contrastText' : color === 'warning' ? 'warning.contrastText' : 'info.contrastText',
        px: 3,
        py: 1.5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 2,
      }}
    >
      <Box display="flex" alignItems="center" gap={2} flex={1}>
        <Box flex={1} maxWidth={200}>
          <Typography variant="body2" fontWeight="bold" mb={0.5}>
            {daysRemaining} {daysRemaining === 1 ? 'day' : 'days'} left in trial
          </Typography>
          <LinearProgress
            variant="determinate"
            value={progress}
            sx={{
              height: 6,
              borderRadius: 3,
              bgcolor: 'rgba(255,255,255,0.3)',
              '& .MuiLinearProgress-bar': {
                bgcolor: 'white',
              },
            }}
          />
        </Box>
        <Typography variant="body2" sx={{ display: { xs: 'none', sm: 'block' } }}>
          Upgrade now to keep all your data and unlock premium features.
        </Typography>
      </Box>

      <Button
        variant="contained"
        size="small"
        onClick={() => navigate('/settings/billing')}
        sx={{
          bgcolor: 'white',
          color: color === 'error' ? 'error.main' : color === 'warning' ? 'warning.dark' : 'info.main',
          '&:hover': {
            bgcolor: 'rgba(255,255,255,0.9)',
          },
        }}
      >
        Upgrade Now
      </Button>
    </Box>
  );
}

export default TrialBanner;
